export const getTextFieldSx = (theme) => ({
  '& .MuiInputBase-root': {
    borderRadius: 1,
    fontSize: '16px',
    minHeight: 48,
    lineHeight: '24px',
  },
  '& .MuiOutlinedInput-input': {
    px: '16px',
    py: '12px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#bababa',
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#797979',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.emphasis.dark,
    borderWidth: '1px',
  },
});

export const getPrimaryButtonSx = (theme) => ({
  backgroundColor: 'emphasis.dark',
  borderRadius: 2,
  boxShadow: 'none',
  color: 'emphasis.contrastText',
  fontSize: '16px',
  fontWeight: theme.typography.fontWeightMedium,
  lineHeight: '24px',
  minHeight: 44,
  px: 5,
  py: 1.25,
  textTransform: 'none',
  width: '100%',
  '&:hover': {
    backgroundColor: 'emphasis.main',
    boxShadow: 'none',
  },
});

export const getSecondaryButtonSx = (theme) => ({
  ...getPrimaryButtonSx(theme),
  backgroundColor: 'transparent',
  borderColor: 'emphasis.dark',
  color: 'emphasis.dark',
  '&:hover': {
    backgroundColor: 'rgba(0, 28, 101, 0.04)',
    borderColor: 'emphasis.dark',
    boxShadow: 'none',
  },
});
